/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';

/**
 * 
 * @export
 * @interface RechercheStatPresenceApprenantSearch
 */
export interface RechercheStatPresenceApprenantSearch {
    /**
     * 
     * @type {StringListSearch}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    anneeScolaire?: StringListSearch;
    /**
     * 
     * @type {number}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {DateSearch}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    dateDebut?: DateSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    dateFin?: DateSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheStatPresenceApprenantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheStatPresenceApprenantSearch interface.
 */
export function instanceOfRechercheStatPresenceApprenantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheStatPresenceApprenantSearchFromJSON(json: any): RechercheStatPresenceApprenantSearch {
    return RechercheStatPresenceApprenantSearchFromJSONTyped(json, false);
}

export function RechercheStatPresenceApprenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheStatPresenceApprenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : StringListSearchFromJSON(json['anneeScolaire']),
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : DateSearchFromJSON(json['dateDebut']),
        'dateFin': !exists(json, 'dateFin') ? undefined : DateSearchFromJSON(json['dateFin']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheStatPresenceApprenantSearchToJSON(value?: RechercheStatPresenceApprenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeScolaire': StringListSearchToJSON(value.anneeScolaire),
        'idApprenant': value.idApprenant,
        'dateDebut': DateSearchToJSON(value.dateDebut),
        'dateFin': DateSearchToJSON(value.dateFin),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

